import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import { discount_options } from "../../Shared/List"

const UserForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [roleOption, setRoleOption] = useState([])
    const [employeeOption, setEmployeeOption] = useState([])
    const [discountOption, setDiscountOption] = useState([])

    const [formData, setFormData] = useState({
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        role_id: "",
        employee_id: null,
        enable_discount: "No",
    })
    const {username, email, password, confirm_password, role_id, employee_id, enable_discount} = formData

    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        setDiscountOption(discount_options.map(option => ({
            id: option.id, 
            key: option.key, 
            name: option.name
        })));

        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        //find discount name with its index
        const enable_discount_name = discount_options[formData?.enable_discount - 1]?.name || 'No'
        const payload = {username, email, password, confirm_password, role_id, employee_id, enable_discount: enable_discount_name}
        addUser(payload)
    }
    
    // add user
    const addUser = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/users/', payload)
            if (response.status === 201){
                toast.success(response.data?.detail)
                navigate('/users')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New User</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="UserName"
                                name="username"
                                type="text"
                                required="required"
                                label="UserName"
                                value={username}
                                onChange={onChange}
                                error={errors.username}
                            />
                        </div>

                        <div className="col-md-4">
                            <InputField
                                placeholder="Password"
                                name="password"
                                type="password"
                                required="required"
                                label="Password"
                                value={password}
                                onChange={onChange}
                                error={errors.password}
                            />
                        </div>

                        <div className="col-md-4">
                            <InputField
                                placeholder="Confirm Password"
                                name="confirm_password"
                                type="password"
                                required="required"
                                label="Confirm Password"
                                value={confirm_password}
                                onChange={onChange}
                                error={errors.confirm_password}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Email"
                                name="email"
                                type="email"
                                required="required"
                                label="Email"
                                value={email}
                                onChange={onChange}
                                error={errors.email}
                            />
                        </div>
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="role_id"
                                label="Role"
                                value={role_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('roles', query, setRoleOption)}
                                options={roleOption}
                                placeholder="Start typing to search..."
                                error={errors.role_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="employee_id"
                                label="Employee (Optional)"
                                value={employee_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('employees', query, setEmployeeOption)}
                                options={employeeOption}
                                placeholder="Start typing to search..."
                                error={errors.employee_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectField
                                name="enable_discount"
                                label="Enable Discount"
                                value={parseInt(enable_discount)}
                                options={discountOption}
                                onChange={onChange}
                                error={errors.enable_discount}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save User" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UserForm
